import React from 'react';
import { stats } from '../data/content';
export function Stats() {
  return <section aria-label="The system at a glance" className="bg-charcoal px-4 py-10 md:py-12" data-id="element-217" data-mp="2wxqf6edmwmjh">
      <ul className="mx-auto grid max-w-6xl grid-cols-2 gap-3 md:grid-cols-5" data-id="element-218" data-mp="2ixxnoguaa2ag">
        {stats.map(([value, label], index) => <li key={label} className={`rounded-2xl border border-ivory/10 bg-ivory/[0.04] p-5 text-center ${index === 4 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-219" data-mp="2nw8xwsohqet7" data-mpi={index}>
            <p className="font-display text-4xl font-black leading-none text-gold md:text-5xl" data-id="element-220" data-mp="2dzdy86ghe8dc">
              {value}
            </p>
            <p className="mt-2 text-[11px] font-bold uppercase leading-tight tracking-wider text-ivory/75 md:text-xs" data-id="element-221" data-mp="2090vqjmczlve">
              {label}
            </p>
          </li>)}
      </ul>
    </section>;
}